import IAppLogger from './IAppLogger';
import IAppManager from './IAppManager';

/**
 * The `AppMonitor` class is responsible for monitoring the application's state
 * and emitting events when the application wakes up from a sleep state. It uses
 * an interval to periodically check the state of the application.
 *
 * @class
 *
 * @param {IAppManager} appManager - The application manager instance used to
 * manage the application and log events.
 * *
 * @method enable - Enables the monitoring by setting up an interval to check
 * the application's state.
 * @method checkState - Checks if the application has been in a sleep state and
 * emits an 'app.wake' event if it has.
 */
export class AppMonitor {
  private readonly _manager: IAppManager;
  private readonly _logger: IAppLogger;
  private _lastCheckedAt: number = Date.now();

  constructor(appManager: IAppManager) {
    this._manager = appManager;
    this._logger = appManager.logger('app', 'info');

    // register awake event
    this._manager.events.registerEvent('app.wake');
  }

  public enable() {
    // setup interval to check for sleep state
    setInterval(this.checkState.bind(this), 1000);
  }

  private checkState() {
    if (Date.now() - this._lastCheckedAt > 30000) {
      this._logger.info('App is waking up...');
      this._manager.events.emit('app.wake');
    }

    this._lastCheckedAt = Date.now();
  }
}

export default AppMonitor;
